import { render, staticRenderFns } from "./AdvertiserMobilePhoneNumberField.vue?vue&type=template&id=4b97a47f&scoped=true"
import script from "./AdvertiserMobilePhoneNumberField.vue?vue&type=script&lang=ts"
export * from "./AdvertiserMobilePhoneNumberField.vue?vue&type=script&lang=ts"
import style0 from "./AdvertiserMobilePhoneNumberField.vue?vue&type=style&index=0&id=4b97a47f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b97a47f",
  null
  
)

export default component.exports